import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — a 2.4 x 1.0 meeting table on 3x1 tiles: walnut top at
// 0.74 carried by two solid slab legs and a matte-black stretcher.
const TOP = "#7a5a3a";
const SLAB = "#6b4e33";
const STRETCHER = "#2e2e30";

export const conferenceTable = defineModel({
  id: "conference-table",
  batchId: "modern",
  name: "Conference table",
  tags: ["modern", "interior", "furniture", "office", "table", "meeting"],
  summary: "A 2.4-metre walnut meeting table on two slab legs.",
  tiles: { w: 3, h: 1 },
  footprint: 1.6,
  parts(): Part[] {
    return [
      // walnut top (top surface at 0.74)
      { geometry: new THREE.BoxGeometry(2.4, 0.05, 1.0), color: TOP, position: [0, 0.715, 0] },
      // two slab legs
      { geometry: new THREE.BoxGeometry(0.08, 0.69, 0.8), color: SLAB, position: [-0.9, 0.345, 0] },
      { geometry: new THREE.BoxGeometry(0.08, 0.69, 0.8), color: SLAB, position: [0.9, 0.345, 0] },
      // low stretcher beam joining the slabs
      { geometry: new THREE.BoxGeometry(1.8, 0.06, 0.1), color: STRETCHER, position: [0, 0.16, 0] },
    ];
  },
  animations: [],
});
